import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit"
import * as Sentry from "@sentry/react"
import { profileSlice } from "src/features/profile"
import { commonSharedUISlice } from "src/features/shared-module/slices"
import { dashboardSlice } from "../slices/dashboard.slice"
import { routePlanningSlice } from "../slices/dispatcherRoutePlan.slice"
import { wsSlice } from "../slices/wsSlice"
import { baseApi } from "./baseApi"

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    profile: profileSlice.reducer,
    dashboard: dashboardSlice.reducer,
    toast: commonSharedUISlice.reducer,
    routePlanning: routePlanningSlice.reducer,
    ws: wsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer)
  },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
